export default __webpack_public_path__ + "static/font-b8c2a8360734269e69967e036f8dadd8.woff2";